import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../interceptor/axiosInstance";
import NotificationService from "../../Utils/NotificationService";

const ReactGuide = () => {
  const [orgCode, setOrgCode] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setOrgCode("YOUR_ORG_CODE");
        return;
      }
      try {
        const response = await axiosInstance.get(`/org/org-details`);
        const data = response.data[0];
        setOrgCode(data.organisation_code);
      } catch (error) {
        console.error('Error fetching organization details:', error);
        setOrgCode("YOUR_ORG_CODE");
      }
    };
    fetchOrgDetails();
  }, []);

  const reactCode = `
import React, { useEffect } from 'react';

const EzzdeskWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://ezzdesk.com/shared_prompt.js?code=${orgCode}";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return <div id="chat-bot-container"></div>;
};

export default EzzdeskWidget;
  `.trim();

  const handleCopy = () => {
    navigator.clipboard.writeText(reactCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      NotificationService.error('Failed to copy text: ' + err);
    });
  };

  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#ffffff',
      color: '#333',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        Adding Ezzdesk Widget to React App
      </h1>
      
      <p style={{ fontSize: '16px', marginBottom: '30px', color: '#555' }}>
        Follow these steps to integrate the Ezzdesk chat widget into your React application by creating a custom component.
      </p>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>1. Create the Widget Component</h3>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '15px' }}>
          Create a new file named <code>EzzdeskWidget.js</code> in your React project's components folder and paste the code below.
        </p>
        <div style={{ position: 'relative' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {reactCode}
          </pre>
          <button
            onClick={handleCopy}
            className='btn-color'
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              padding: '6px 16px',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>2. Render the Widget in your App</h3>
        <ul style={{ fontSize: '15px', color: '#666', paddingLeft: '20px' }}>
          <li style={{ marginBottom: '10px' }}>Open your main layout component, usually <code>App.js</code>.</li>
          <li style={{ marginBottom: '10px' }}>Import the new widget component: <br/><code>import EzzdeskWidget from './components/EzzdeskWidget';</code></li>
          <li>Place <code>&lt;EzzdeskWidget /&gt;</code> within your main app component rendering tree.</li>
        </ul>
      </div>

      <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', borderLeft: '4px solid #007BFF' }}>
        <h4 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>Need Help?</h4>
        <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>
          If you encounter any issues while installing the widget, feel free to contact our support team.
        </p>
      </div>
    </div>
  );
};

export default ReactGuide;
